import { DateFormat, formatDate, formateDateTimeForLastSeen } from "../../utils/datePareser";
import { localStorageKeys } from "../../utils/localStorageKeys";
import AuthenticationResponse from "../responses/AuthenticationResponse";
import { HostChatMessage, Offer } from "../../types";
import { formatChatMessageForDisplay } from "../../utils/chatMessageText";

class ChatBubble {
  senderName: string;
  timestamp: string;
  message: string;
  type: string;
  lastSeen: Date;
  fromUserId: string;

  constructor(senderName: string, timestamp: string, message: string,
    type: string, lastSeen: Date, fromUserId: string) {
    this.senderName = senderName;
    this.timestamp = timestamp;
    this.message = message;
    this.type = type;
    this.lastSeen = lastSeen;
    this.fromUserId = fromUserId;
  }
}

class ChatModel {
  groupAdminId: string;
  headerTitle: string;
  headerSub: string;
  lastSeen: string;
  userId: string
  bubbles: ChatBubble[];
  offerId: string;
  toUserId: string

  constructor(
    groupAdminId: string,
    headerTitle: string,
    headerSub: string,
    lastSeen: string,
    userId: string,
    bubbles: ChatBubble[],
    offerId: string,
    toUserId: string
  ) {
    this.groupAdminId = groupAdminId;
    this.headerTitle = headerTitle;
    this.headerSub = headerSub;
    this.lastSeen = lastSeen;
    this.userId = userId;
    this.bubbles = bubbles;
    this.offerId = offerId;
    this.toUserId = toUserId
  }

  static getData(
    hostChatMessages: HostChatMessage[],
    offer: Offer,
    groupAdminName: string,
    userId: string,
    toUserId: string,
    groupAdminId: string
  ): ChatModel {

    let headerTitle: string = "";

    if (offer.offerType === "TableBooking") {
      headerTitle = `${groupAdminName.split(' ')[0]} for Table`;
    } else if (offer.offerType === "GuestList") {
      headerTitle = `${groupAdminName.split(' ')[0]} for Guest`;
    } else {
      headerTitle = `${groupAdminName.split(' ')[0]} for Join VIP Table`
    }

    const headerSub = `${offer.clubName} on ${formatDate(new Date(offer.partyDate), false, DateFormat.Long, true)}`;

    const userInfo: AuthenticationResponse = JSON.parse(localStorage.getItem(localStorageKeys.loginResponse) as string);
    const userFullName = `${userInfo.firstName} ${userInfo.lastName}`

    const filteredMessage = hostChatMessages?.filter(m => m.senderName !== userFullName && m.senderName != userInfo.firstName && m.senderName !== "Clubbable" &&
      m.senderName.startsWith(groupAdminName));
    const lastSeen = filteredMessage.length > 0 ? formateDateTimeForLastSeen(filteredMessage[0].lastLogin) : "";

    const currentUserId = userId;
    const bubble = hostChatMessages.map((chat) => {
      return new ChatBubble(
        chat.senderName,
        chat.timestamp,
        formatChatMessageForDisplay(chat.message),
        chat.type,
        chat.lastLogin,
        chat.fromUserId
      );
    });

    const chatModel1 = new ChatModel(groupAdminId, headerTitle, headerSub, lastSeen, currentUserId, bubble, offer.id, toUserId);

    return chatModel1;
  }
}

export { ChatModel, ChatBubble };
